import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyC8lmzBBGZC-KgDeMiv5sdBuqA3fe7tS9k",
    authDomain: "traveladvisorapp-893b0.firebaseapp.com",
    projectId: "traveladvisorapp-893b0",
    storageBucket: "traveladvisorapp-893b0.firebasestorage.app",
    messagingSenderId: "82144501247",
    appId: "1:82144501247:web:592c6bc989d1bd82945bca"
  };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);